module.exports = __webpack_public_path__ + "static/media/3@2x.d3e70580.png";